import React, { useMemo } from 'react';
import { Select, SelectOption, TextInput } from '@spoiler-alert/ui-library';
import { createUseStyles } from 'react-jss';
import { logisticsOptions, propTypes, styles } from './site-editing-helpers';
import HTMLEditor from '../../../components/editor/html-editor';
import EmailList from '../../../components/email-list/email-list';
import accounting from 'accounting';

const useStyles = createUseStyles(styles);

const TransactionServices = ({ site, setFieldValue }) => {
  const classes = useStyles();

  const selectedLogisticsOptions = useMemo(() => {
    return site.transactionServicesSettings?.supportedLogisticsOptions?.map((role) => ({
      value: role,
      text: logisticsOptions[role],
    }));
  }, [site.transactionServicesSettings?.supportedLogisticsOptions]);

  return (
    <div className={classes.box}>
      <div className={classes.half}>
        <Select
          label="Accepting Logistics Options"
          multiple
          selectedItems={selectedLogisticsOptions}
          onChange={setFieldValue.bind(
            this,
            'select-multiple',
            'transactionServicesSettings.supportedLogisticsOptions',
          )}
        >
          <SelectOption value="DELIVERY">Delivery</SelectOption>
          <SelectOption value="PICKUP">Pickup</SelectOption>
        </Select>
      </div>
      <div className={classes.half}>
        <TextInput
          value={site.transactionServicesSettings?.numocoCompanyId || ''}
          labelText="NUMOCO Company Id"
          onChange={setFieldValue.bind(this, 'text', 'transactionServicesSettings.numocoCompanyId')}
        />
      </div>
      <div className={classes.half}>
        <TextInput
          value={`${accounting.formatNumber((site.transactionServicesSettings?.takeRate || 0) / 100)}%` || ''}
          labelText="Take Rate"
          onChange={(value) =>
            setFieldValue('number', 'transactionServicesSettings.takeRate', accounting.unformat(value) * 100)
          }
        />
      </div>
      <div className={classes.half}>
        <TextInput
          value={`${site.transactionServicesSettings?.supplierPaymentDueDays || 0}`}
          labelText="Supplier Payment Due Days"
          onChange={setFieldValue.bind(this, 'number', 'transactionServicesSettings.supplierPaymentDueDays')}
        />
      </div>
      <div className={classes.half}>
        <TextInput
          value={`${site.transactionServicesSettings?.buyerPaymentDueDays || 0}`}
          labelText="Buyer Payment Due Days"
          onChange={setFieldValue.bind(this, 'number', 'transactionServicesSettings.buyerPaymentDueDays')}
        />
      </div>
      <EmailList
        label="Packing List Contacts"
        list={site.transactionServicesSettings?.packingListContacts || []}
        onChange={setFieldValue.bind(this, 'text[]', 'transactionServicesSettings.packingListContacts')}
      />
      <div className={classes.half}>
        <TextInput
          value={site.transactionServicesSettings?.pickupLeadTime || ''}
          labelText="Pickup Lead Time"
          onChange={setFieldValue.bind(this, 'text', 'transactionServicesSettings.pickupLeadTime')}
        />
      </div>
      <HTMLEditor
        defaultValue={site.transactionServicesSettings?.paymentTerms || ''}
        labelText="Payment Terms"
        onChange={setFieldValue.bind(this, 'text', 'transactionServicesSettings.paymentTerms')}
      />
      <HTMLEditor
        defaultValue={site.transactionServicesSettings?.channelRestrictions || ''}
        labelText="Channel Restrictions"
        onChange={setFieldValue.bind(this, 'text', 'transactionServicesSettings.channelRestrictions')}
      />
    </div>
  );
};

TransactionServices.propTypes = propTypes;

export default TransactionServices;
